module.exports = ".body {\r\n\tbackground: #431462;\r\n}"